/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2029
 */

"use strict"

exports.decode = exports.parse = require(/* 2030 */"./2030")
exports.encode = exports.stringify = require(/* 2031 */"./2031")
